import { render, staticRenderFns } from "./style-guide.vue?vue&type=template&id=35c6bc52&scoped=true&"
import script from "./style-guide.vue?vue&type=script&lang=js&"
export * from "./style-guide.vue?vue&type=script&lang=js&"
import style0 from "./style-guide.vue?vue&type=style&index=0&id=35c6bc52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c6bc52",
  null
  
)

export default component.exports